// User
export const USER_UPDATED = 'USER_UPDATED';
export const USER_DATA_UPDATED = 'USER_DATA_UPDATED';

// Affiliations
export const USER_AFFILIATION_UPDATED = 'USER_AFFILIATION_UPDATED';
export const USER_AFFILIATION_REMOVED = 'USER_AFFILIATION_REMOVED';

// Preferences
export const USER_PREFERENCES_UPDATED = 'USER_PREFERENCES_UPDATED';
